import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(
      public auth: AuthService,
      public router: Router
    ) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        // console.log('auth guard called', state.url, route.url);
        const reverseAuthGuard: boolean = route.data['authGuardReverse'];
        const isLoggedIn: boolean = this.auth.getApiKey() ? true : false;

        if (!isLoggedIn && !reverseAuthGuard) {
            // console.warn('not logged in, redirect to login');
            this.router.navigate(['login']);
            return false;
        } else if (isLoggedIn && reverseAuthGuard) {
            // console.warn('logged in, but reverseAuthGuard called, redirect to dashboard');
            this.router.navigate(['dashboard'], {replaceUrl: true});
            return false;
        }
        // console.warn('logged in, and no reverseAuthGuard called active is allowed');
        return true;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.canActivate(childRoute, state);
    }
}
